import http from "../../../src/util/axios";
import config from "../../../config/endpoints";

const PH_URL = config.ph_url;
const API_URL = config.chs_url

export default {
  namespaced: true,
  state: {
    inAppNotification: {},
    questionaryDetails: null,
    empId:{},
    empNotification: [],
    empFlag: false,
    empCount: null,
    captionNotification: null,
    slctdEmployee: "",
    chatShow: false,
    showLocChat: false
  },
  mutations: {
    SET_INAPP_NOTIFICATION:(state, payload) => {
        state.inAppNotification = payload
    },
    SET_EMP_ID:(state,payload) =>{
      state.empId = payload
    },
    SET_QUESTIONARY_DETAILS: (state, payload) => {
        state.questionaryDetails = payload
    },
    SET_EMP_NOTIFICATION:(state, payload) => {
      state.empNotification = payload
  },
  SET_EMP_FLAG:(state, payload) => {
      state.empFlag = payload
  },
  SET_EMP_COUNT: (state, payload) => {
    state.empCount = payload
},
  SET_CAPTION_NOTIFICATION: (state, payload) => {
    state.captionNotification = payload;
  },
  SET_ACTIVE_EMP_TAB: (state, payload) => {
    state.slctdEmployee = payload 
  },
  SET_CHAT_STATUS: (state, payload) => {
    state.chatShow = payload;
  },
  SET_LOC_CHAT_STATUS: (state, payload) => {
    state.showLocChat = payload;
  }
  },
  actions: {
    GET_SERVICE_DATA({ commit } , payload) {
        return http.post(PH_URL + '/v5/manual/allDetails' , payload).then(response => {
            const { status, data, message, desc, title, search_place_holder } = response
            if (data) {
                return { status: status, data: data, title, search_place_holder }
            } else {
                return { status: status, message: desc || message, title, search_place_holder }
            }
        })
    },
    GET_BUPA_SERVICES({ commit } , payload) {
      return http.post(PH_URL + '/v5/manual/bupaOfflinePackages' , payload).then(response => {
          const { status, data, message, desc, title, search_place_holder } = response
          if (data) {
              return { status: status, data: data, title, search_place_holder }
          } else {
              return { status: status, message: desc || message, title, search_place_holder }
          }
      })
  },
    GET_EMPNOTIFICATION({ commit } , payload) {
      return http.post(API_URL + '/employee/status' , payload).then(response => {
        const { status, message, data } = response
        if(status === 1000) {
          commit('SET_EMP_NOTIFICATION', data.details)
          if(!payload.eid) {
            commit('SET_EMP_COUNT', data.total_act)
          }
        }
        return data
      })
  },
  GET_EMPINFO({ commit } , payload) {
    return http.post(API_URL + '/employee/status-list' , payload).then(response => {
      return response
    })
},
GET_EMPHISTORY({ commit } , payload) {
  return http.post(API_URL + '/employee/status-history' , payload).then(response => {
    return response
  })
},
    INAPP_NOTIFICATION:({ commit }, payload) => {
        commit('SET_INAPP_NOTIFICATION', payload)
    },
    EMP_NOTIFICATION:({ commit }, payload) => {
      commit('SET_EMP_NOTIFICATION', payload.details)
      commit('SET_EMP_COUNT', payload.total_act)
      commit('SET_EMP_FLAG', true)
    },
    CAPTION_NOTIFICATION:({commit}, payload) => {
      commit('SET_CAPTION_NOTIFICATION', payload)
    }
  },
  getters: {
    getInAppNotification: state => state.inAppNotification,
    getSavedQuestionary: state => state.questionaryDetails,
    getEmpNotification: state => state.empNotification,
    getEmpFlag: state => state.empFlag,
    getEmpCount: state => state.empCount,
    getCaptainNotification: state => state.captionNotification,
    getEmployeeId: state => state.empId,
    getActiveEmpTab: state => state.slctdEmployee,
    getChatStatus: state => state.chatShow,
    getLocChatStatus: state => state.showLocChat
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/common.js